import { useState } from "react";
import { isIOS, isStandalone, useInstallPrompt } from "@/lib/pwa";
import { Smartphone, Share, PlusSquare, X } from "lucide-react";
import { useLang } from "@/context/LangContext";


export const IOSGuide = ({ onClose }) => {
  const { tr } = useLang();
  return (
    <div data-testid="install-ios-guide" className="fixed inset-0 z-[60] bg-black/50 flex items-end sm:items-center justify-center p-4" onClick={onClose}>
      <div className="bg-white w-full max-w-sm p-6 space-y-4" onClick={(e) => e.stopPropagation()}>
        <div className="flex items-center justify-between">
          <h3 className="font-display text-xl">{tr("Installa Aurora-ADV", "Install Aurora-ADV")}</h3>
          <button data-testid="install-ios-close" onClick={onClose}><X className="w-5 h-5" /></button>
        </div>
        <ol className="space-y-3 text-sm text-[#2B3036]">
          <li className="flex items-center gap-3"><Share className="w-5 h-5 text-[#E0262C]" /> {tr("Tocca il pulsante Condividi in Safari", "Tap the Share button in Safari")}</li>
          <li className="flex items-center gap-3"><PlusSquare className="w-5 h-5 text-[#E0262C]" /> {tr("Scegli \"Aggiungi alla schermata Home\"", "Choose \"Add to Home Screen\"")}</li>
          <li className="flex items-center gap-3"><Smartphone className="w-5 h-5 text-[#E0262C]" /> {tr("Apri Aurora-ADV dall'icona come una vera app", "Open Aurora-ADV from the icon like a real app")}</li>
        </ol>
      </div>
    </div>
  );
};

export const InstallAppButton = ({ className = "" }) => {
  const { tr } = useLang();
  const { prompt, install } = useInstallPrompt();
  const [guide, setGuide] = useState(false);
  const [installed, setInstalled] = useState(isStandalone());
  if (installed || (!prompt && !isIOS())) return null;
  const click = async () => {
    if (!prompt) return setGuide(true);
    if (await install()) setInstalled(true);
  };
  return (
    <>
      <button data-testid="install-app-btn" onClick={click} aria-label={tr("Installa l'app", "Install the app")} title={tr("Installa l'app", "Install the app")}
        className={`inline-flex shrink-0 items-center justify-center gap-1.5 h-9 w-9 sm:w-auto sm:px-3 border border-[#2B3036] text-[#2B3036] text-xs font-medium whitespace-nowrap hover:bg-[#2B3036] hover:text-white transition-colors ${className}`}>
        <Smartphone className="w-4 h-4" /> <span className="hidden sm:inline">{tr("Installa l'app", "Install the app")}</span>
      </button>
      {guide && <IOSGuide onClose={() => setGuide(false)} />}
    </>
  );
};
